import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    Button,
    Grid,
    Switch,
} from '@mui/material'
import { Google as GoogleIcon } from '@mui/icons-material'
import { UserContext } from '../../contexts/UserContext'
import { toast } from 'react-toastify'
import { createGoogleDriveIntegration } from '../../utils/integrations/googleDriveIntegration'

// TODO: Handle Integrations for other providers
const IntegrationsOnboardingPage = () => {
    const history = useHistory()
    const { user } = useContext(UserContext)

    // Initialize states for toggles
    const [googleEnabled, setGoogleEnabled] = useState(user?.authProvider === 'google')
    const [notionEnabled, setNotionEnabled] = useState(false)

    const handleGoogleToggle = async (event) => {
        try {
            await createGoogleDriveIntegration();
            setGoogleEnabled(event.target.checked);
            toast.success('Google Drive integration enabled');
        } catch (error) {
            setGoogleEnabled(false);
            if (error.message.includes('No authentication token')) {
                toast.error('Please sign in to Google first');
            } else {
                toast.error(`Failed to enable Google Drive: ${error.message}`);
            }
        }
    }

    const handleNotionToggle = async (event) => {
        try {
            // TODO: Implement Paragon Notion integration
            setNotionEnabled(event.target.checked)
            toast.info('Notion integration coming soon!')
        } catch (error) {
            toast.error('Failed to connect to Notion')
        }
    }

    const handleSkip = () => {
        history.push('/myevents')
    }

    const handleContinue = () => {
        // Save the integration preferences if needed
        // TODO: Implement any necessary backend calls to save preferences
        history.push('/myevents')
    }

    return (
        <Container maxWidth="md" sx={{ py: 8 }}>
            <Box textAlign="center" mb={6}>
                <Typography variant="h4" gutterBottom>
                    Enhance Your Experience
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Connect your accounts to get the most out of Happenings
                </Typography>
            </Box>

            <Grid container spacing={3} justifyContent="center">
                {/* Google Integration Card */}
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Box display="flex" alignItems="center" gap={2}>
                                <GoogleIcon sx={{ fontSize: 48, color: '#4285F4' }} />
                                <Box flex={1}>
                                    <Typography variant="h6">Google Calendar & Drive</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Sync your events with Google Calendar and access files from Drive
                                    </Typography>
                                </Box>
                                <Switch
                                    checked={googleEnabled}
                                    onChange={handleGoogleToggle}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Box 
                display="flex" 
                justifyContent="center" 
                gap={2} 
                mt={4}
            >
                <Button 
                    variant="text" 
                    onClick={handleSkip}
                >
                    Skip for now
                </Button>
                <Button 
                    variant="contained" 
                    onClick={handleContinue}
                    sx={{ minWidth: 120 }}
                >
                    Continue
                </Button>
            </Box>
        </Container>
    )
}

export default IntegrationsOnboardingPage 